import React, { useState } from "react";
import { OverviewIcon } from "@util/svgicon";
import ErrorPic from "@images/profile/emergency_home.svg";
import SettingPic from "@images/profile/settings.svg";
import ProfileSetting from "./ProfileSetting";
import OverViewProfile from "./OverviewProfile";

const RightSection = () => {
  const [setting, setSetting] = useState('next')

  const handaleNext = () => {
    setSetting('next')
  }
  
  return (

    <div className="flex h-full p-[36px] flex-col items-start gap-[24px] rounded-[32px] overflow-y-auto bg-[#EFEFEF] [box-shadow:0px_4px_4px_0px_rgba(0,_0,_0,_0.25)] backdrop-filter">
      {setting === 'next' ? <ProfileSetting onclick={() => setSetting()} /> :
        <div className="flex flex-col items-start gap-[36px] w-full">
          <div className="flex justify-between w-full">
            <div className="flex items-center gap-[8px]">
              <OverviewIcon />
              <p className="text-[#000] text-[32px] font-semibold leading-[32px] tracking-[-1.92px]">
                Overview
              </p>
            </div>
            <div className="flex gap-4">
              <div className="flex items-center gap-[8px]">
                <div>
                  <img src={ErrorPic} alt="UserProfile" />
                </div>
                <button onClick={handaleNext}>
                  <p className="text-red font-medium underline leading-[15px]">
                    Review Warnings
                  </p>
                </button>
              </div>
              <div>
                <button className="flex w-full px-[12px] py-[6px] justify-center items-center gap-[10px] rounded-[32px] bg-[#000]" onClick={handaleNext}>
                  <p className="text-white flex gap-[4px]">
                    <img src={SettingPic} />
                    Profile Settings
                  </p>
                </button>
              </div>
            </div>
          </div>
          {/* <div className="w-full">
            <OverViewProfile />
          </div> */}
        </div>
      }

    </div>
  );
};

export default RightSection;
